import { render, staticRenderFns } from "./IconPhoneVisitBlack.vue?vue&type=template&id=4f05a4b8"
import script from "./IconPhoneVisitBlack.vue?vue&type=script&lang=js"
export * from "./IconPhoneVisitBlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports